import { Component } from '@angular/core';
import { detectBody } from '../../../app.helpers';

declare var jQuery:any;

@Component({
  selector: 'client',
  templateUrl: 'clientLayout.template.html',
  host: {
    '(window:resize)': 'onResize()'
  }
})
export class ClientLayoutComponent {

  public ngOnInit():any {
    detectBody();
  }

  public onResize(){
    detectBody();
  }

}
